export type CookieConsent = 'accepted' | 'rejected';

const STORAGE_KEY = 'tropel_cookie_consent_v1';

export function getCookieConsent(): CookieConsent | null {
  if (typeof window === 'undefined') return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === 'accepted' || value === 'rejected' ? value : null;
  } catch {
    return null;
  }
}

export function setCookieConsent(value: CookieConsent): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    return;
  }
}

export function hasRejectedCookies(): boolean {
  return getCookieConsent() === 'rejected';
}

export function trackingAllowed(): boolean {
  return getCookieConsent() !== 'rejected';
}
